export default __webpack_public_path__ + "static/media/bloodbath7.c9bb13b4.png";